import { createFileRoute } from '@tanstack/react-router';
import { StatCardCount } from '@/components/Card/StatCard/variation/StatCardCount';
import ComingSoonCover from '@/components/ComingSoonCover';
import { Grid, VStack } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import { MOCK_ONLY_FEATURE_FLAG } from '@/constants/featureFlags';
import { featureFlags } from '@/lib/env';
import placeholder from '../_placeholders/-assets/placeholder-overview.png';
import { RecentActivityCard } from './-components/RecentActivityCard';
import { RenewalScheduleCard } from './-components/RenewalScheduleCard';
import { useLicenseOverview } from './-query';
export const Route = createFileRoute('/_staff/licenses/_list/')({
  component: LicenseOverview
});
function LicenseOverview() {
  const isMockEnabled = featureFlags.check(MOCK_ONLY_FEATURE_FLAG);
  const {
    data,
    isPending
  } = useLicenseOverview({
    enabled: isMockEnabled
  });

  // MOCK_ONLY 無効時は従来どおり ComingSoon（非破壊）
  if (!isMockEnabled) {
    return <ComingSoonCover placeholderImage={placeholder} />;
  }
  if (isPending || !data) {
    return <ViewportLoader />;
  }
  return <VStack className="gap-6 px-12 py-5">
      <Grid columns={4} columnGap={24} rowGap={24}>
        <StatCardCount title="保有ライセンス" highlight={{
        label: data.totalSeats.total,
        suffix: 'シート'
      }} data={data.totalSeats.bySoftware} className="h-[420px]" />
        <StatCardCount title="利用中ライセンス" highlight={{
        label: data.assignedSeats.total,
        suffix: 'シート'
      }} data={data.assignedSeats.bySoftware} className="h-[420px]" />
        <StatCardCount title="空きライセンス" highlight={{
        label: data.availableSeats.total,
        suffix: 'シート'
      }} data={data.availableSeats.bySoftware} className="h-[420px]" />
        <StatCardCount title="要対応アラート" highlight={{
        label: data.alerts.total,
        suffix: '件'
      }} data={data.alerts.byCategory} className="h-[420px]" />
        <RenewalScheduleCard renewals={data.renewals} className="col-span-2" />
        <RecentActivityCard activities={data.activities} className="col-span-2" />
      </Grid>
    </VStack>;
}